(() => {
  if (window.__auA11yFocusGuard) return;
  window.__auA11yFocusGuard = true;

  let lastFocusOutside = null;

  document.addEventListener(
    "focusin",
    (e) => {
      const t = e.target;
      if (!t || typeof t.closest !== "function") return;
      if (!t.closest('[aria-hidden="true"]')) lastFocusOutside = t;
    },
    { passive: true }
  );

  const rescue = (root) => {
    const active = document.activeElement;
    if (!active || !root.contains(active)) return;
    active.blur();
    if (lastFocusOutside && document.body.contains(lastFocusOutside) && !lastFocusOutside.closest('[aria-hidden="true"]')) {
      lastFocusOutside.focus();
    }
  };

  new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.attributeName === "aria-hidden" && m.target.getAttribute("aria-hidden") === "true") {
        rescue(m.target);
      }
    }
  }).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["aria-hidden"],
    subtree: true,
  });
})();

(function () {
  var KEY = 'au:market-switch-from';

  function here() {
    return window.location.pathname + window.location.search;
  }

  function findValue(target) {
    if (!target || !target.closest) return null;
    var option = target.closest('.disclosure--option');
    if (!option) return null;
    var root = option.closest('.disclosure--root[data-type="localization"]');
    if (!root) return null;
    var form = root.closest('form[action="/localization"]');
    if (!form) return null;
    var hidden = root.querySelector('.disclosure--input');
    if (!hidden || !hidden.name) return null;
    var value = option.getAttribute('data-value');
    if (!value || value === 'undefined') return null;
    return { form: form, hidden: hidden, value: value };
  }

  function submit(found) {
    if (found.hidden.name === 'country_code') {
      try {
        window.sessionStorage.setItem(KEY, here());
      } catch (e) {}
    }
    found.hidden.setAttribute('value', found.value);
    found.hidden.value = found.value;
    found.form.submit();
  }

  document.addEventListener(
    'click',
    function (event) {
      var found = findValue(event.target);
      if (!found || found.hidden.value === found.value) return;
      submit(found);
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Enter') return;
      var found = findValue(event.target);
      if (!found || found.hidden.value === found.value) return;
      submit(found);
    },
    true
  );

  var from;
  try {
    from = window.sessionStorage.getItem(KEY);
    window.sessionStorage.removeItem(KEY);
  } catch (e) {
    return;
  }

  if (!from || from === here()) return;
  if (window.location.pathname !== '/') return;
  if (from.indexOf('/products/') !== 0 && from.indexOf('/collections/') !== 0) return;
  if (from.indexOf('//') === 0) return;

  window.location.replace(from);
})();

(function () {
  "use strict";

  var MAX_DEPTH = 12;

  function slice(list) {
    return Array.prototype.slice.call(list);
  }

  function step(menu, tries) {
    if (tries > MAX_DEPTH) return;
    var root = menu.id ? menu.id + "-panel" : null;
    var open = menu.querySelector('ul[aria-current="true"]');
    if (!open || (root && open.id === root)) return;
    var back = open.querySelector(":scope > .y-menu--back-link > button");
    if (!back) return;
    try {
      back.click();
    } catch (e) {
      return;
    }
    requestAnimationFrame(function () {
      step(menu, tries + 1);
    });
  }

  function resetAll() {
    slice(document.querySelectorAll("y-menu-element")).forEach(function (m) {
      step(m, 0);
    });
  }

  window.addEventListener("theme:drawer:left:closed", resetAll);

  document.addEventListener("click", function (e) {
    var thumb = e.target && e.target.closest ? e.target.closest(".y-menu--level-2-image") : null;
    var link = thumb && thumb.nextElementSibling;
    if (link && link.tagName === "A") link.click();
  });
})();

(function () {
  "use strict";

  var sync = function (container) {
    var wrapper = container.querySelector(".x-menu--level-2--wrapper");
    var h = wrapper ? wrapper.offsetHeight : container.scrollHeight;
    if (h > 0) container.style.setProperty("--natural-height", h + "px");
  };

  var observers = [];

  var init = function () {
    while (observers.length) {
      try {
        observers.pop().disconnect();
      } catch (_) {}
    }
    document.querySelectorAll(".x-menu--level-1--link").forEach(function (link) {
      if (!link.querySelector(".au-xm-item")) return;
      var container = link.querySelector(".x-menu--level-2--container");
      if (!container) return;

      var observer = new MutationObserver(function () {
        if (container.getAttribute("aria-hidden") === "false") {
          requestAnimationFrame(function () {
            sync(container);
          });
        }
      });
      observer.observe(container, { attributes: true, attributeFilter: ["aria-hidden"] });
      observers.push(observer);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();

(function () {
  "use strict";

  var vv = window.visualViewport;
  if (!vv) return;

  var viewport = document.querySelector(".layout--viewport");

  var sync = function () {
    if (!viewport || viewport.getAttribute("data-drawer-view") !== "search") return;
    var panels = document.querySelectorAll(".au-search");
    if (!panels.length) return;
    var kb = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
    panels.forEach(function (panel) {
      panel.style.setProperty("--au-search-kb", kb + "px");
    });
  };

  var schedule = function () {
    requestAnimationFrame(sync);
  };

  vv.addEventListener("resize", schedule);
  vv.addEventListener("scroll", schedule);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", sync);
  } else {
    sync();
  }
})();

document.getElementById('BackToTop')?.addEventListener('click', function () {
  window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
});

(function () {
  "use strict";

  var queued = false;
  var spinners = new Set();
  var sprite = null;

  function spinning(el) {
    var gate = el.closest("[aria-busy]");
    if (gate && gate.getAttribute("aria-busy") === "true") return true;
    if (gate && !gate.matches("[disabled]")) return false;
    if (typeof el.checkVisibility !== "function") return true;
    return el.checkVisibility({ opacityProperty: true, visibilityProperty: true });
  }

  function sync() {
    queued = false;
    var run = false;
    spinners.forEach(function (spinner) {
      if (!spinner.isConnected) {
        spinners.delete(spinner);
      } else if (!run && spinning(spinner)) {
        run = true;
      }
    });
    var svg = sprite && sprite.ownerSVGElement;
    if (!svg || typeof svg.pauseAnimations !== "function") return;
    if (run && svg.animationsPaused()) svg.unpauseAnimations();
    if (!run && !svg.animationsPaused()) svg.pauseAnimations();
  }

  function queue() {
    if (queued) return;
    queued = true;
    setTimeout(sync, 200);
  }

  function register(root) {
    if (root.nodeType !== 1) return false;
    var found = false;
    if (root.matches(".icon--spinner")) {
      spinners.add(root);
      found = true;
    }
    root.querySelectorAll(".icon--spinner").forEach(function (spinner) {
      spinners.add(spinner);
      found = true;
    });
    return found;
  }

  function containsSpinner(root) {
    var found = false;
    spinners.forEach(function (spinner) {
      if (!found && (root === spinner || root.contains(spinner))) found = true;
    });
    return found;
  }

  function init() {
    sprite = document.querySelector("symbol#loading-spinner");
    document.querySelectorAll(".icon--spinner").forEach(function (spinner) {
      spinners.add(spinner);
    });
    queue();
    new MutationObserver(function (mutations) {
      var changed = false;
      mutations.forEach(function (mutation) {
        if (mutation.type === "childList") {
          mutation.addedNodes.forEach(function (node) {
            if (register(node)) changed = true;
          });
          mutation.removedNodes.forEach(function (node) {
            if (node.nodeType === 1 && containsSpinner(node)) changed = true;
          });
        } else if (containsSpinner(mutation.target)) {
          changed = true;
        }
      });
      if (changed) queue();
    }).observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["aria-busy", "aria-hidden", "disabled"],
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

(function () {
  "use strict";

  function reveal(root) {
    root.querySelectorAll(".au-promo-banner--media:not([data-loaded]) img").forEach(function (img) {
      var media = img.closest(".au-promo-banner--media");
      var done = function () {
        media.setAttribute("data-loaded", "");
      };
      if (img.complete) {
        done();
      } else {
        img.addEventListener("load", done, { once: true });
        img.addEventListener("error", done, { once: true });
      }
    });
  }

  reveal(document);
  document.addEventListener("shopify:section:load", function (e) {
    reveal(e.target);
  });
})();

(function () {
  "use strict";

  var loading = null;

  function loadDefaults() {
    var component = document.querySelector("predictive-search-element.au-search");
    if (!component) return;

    var results = component.querySelector(".search--results");
    var input = component.querySelector(".search--textbox");
    var cache = component.cached_results;
    var emptyHTML = cache && typeof cache.get === "function" ? cache.get("") : results && results.innerHTML;
    if (!results || typeof emptyHTML !== "string" || emptyHTML.indexOf("data-au-search-defaults-placeholder") === -1) return;
    if (loading) return;

    var routeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    var url = new URL(typeof routeRoot === "string" ? routeRoot : "/", window.location.origin);
    url.searchParams.set("section_id", "au-search-defaults");

    var country = new URL(window.location.href).searchParams.get("country");
    if (country) url.searchParams.set("country", country);

    loading = fetch(url.toString(), { credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) throw new Error("Search defaults request failed");
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, "text/html");
        var defaults = parsed.querySelector("[data-au-search-defaults-content]");
        if (!defaults) throw new Error("Search defaults section was empty");

        var styles = parsed.querySelectorAll("style[data-section-stylesheet]");
        if (styles.length && !document.head.querySelector("style[data-au-search-defaults-style]")) {
          styles.forEach(function (style) {
            var copy = style.cloneNode(true);
            copy.setAttribute("data-au-search-defaults-style", "");
            document.head.appendChild(copy);
          });
        }

        var template = document.createElement("template");
        template.innerHTML = emptyHTML;
        var placeholder = template.content.querySelector("[data-au-search-defaults-placeholder]");
        if (!placeholder) return;
        placeholder.replaceWith(defaults.cloneNode(true));

        var updatedHTML = template.innerHTML;
        if (cache && typeof cache.set === "function") cache.set("", updatedHTML);
        if (!input || input.value.trim() === "") results.innerHTML = updatedHTML;
      })
      .catch(function () {
        return null;
      })
      .finally(function () {
        loading = null;
      });
  }

  document.addEventListener(
    "click",
    function (event) {
      if (!event.target || !event.target.closest || !event.target.closest('[data-drawer-open][data-drawer-view="search"]')) return;
      setTimeout(loadDefaults, 0);
    },
    true
  );

  document.addEventListener(
    "focusin",
    function (event) {
      if (event.target && event.target.closest && event.target.closest("predictive-search-element.au-search .search--textbox")) loadDefaults();
    },
    true
  );
})();
